import { axios } from 'lib';
import { useQuery } from 'react-query';

const defaultQueryParams = {
  queryKey: ['consortium-group'],
  queryOptions: {},
};

const getConsortiumGroupById = async (directID, cgId) => {
  const { data } = await axios.get(`/api/directs/${directID}/consortium_groups/${cgId}`);

  return data;
};

export const useConsortiumGroup = (directID, cgId, queryParams = {}) => {
  const { queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  return useQuery([...queryKey, cgId], () => getConsortiumGroupById(directID, cgId), {
    initialData: { cg_name: 'Consortium Group', FA: {} },
    ...queryOptions,
  });
};
